import { render, staticRenderFns } from "./oauth-connect.vue?vue&type=template&id=64d6893a&lang=pug&"
import script from "./oauth-connect.vue?vue&type=script&lang=js&"
export * from "./oauth-connect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports